export default "__VITE_ASSET__DLijs24$__"